module.exports = __webpack_public_path__ + "static/media/texture_inverted2.7aad711b.png";